import { AppBar, IconButton, styled, Toolbar, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const CustomAppBar = styled(AppBar)(({theme}) =>({
    background: `linear-gradient(90deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
    borderRadius:'0 0 20px 20px'
}))


const Header = () =>{

    const navigate =  useNavigate()
    return (
    <CustomAppBar position="static" >
        <Toolbar>
            <IconButton onClick={() => navigate(-1)} sx={{background:'#ffffff5c',marginRight:'10px'}}> <ArrowBackIcon sx={{color:"#fff"}}/> </IconButton>
            <Typography variant="h6" component={Link} to="/" sx={{textDecoration:'none',flexGrow:1}} color="#fff" >CosmeTixhuB</Typography>
        </Toolbar>

    </CustomAppBar>
    )
}


export default Header;